// extracted by mini-css-extract-plugin
export var appear = "styles-module--appear--d33e4";
export var arrowBullet = "styles-module--arrowBullet--12275";
export var backToWork = "styles-module--backToWork--5f99d";
export var backToWorkIcon = "styles-module--backToWorkIcon--4b08a";
export var backToWorkText = "styles-module--backToWorkText--666f1";
export var caseStudiesNavigation = "styles-module--caseStudiesNavigation--dcb75";
export var caseStudyCompany = "styles-module--caseStudyCompany--dc978";
export var caseStudyDescription = "styles-module--caseStudyDescription--8e6bf";
export var caseStudyIntroTitle = "styles-module--caseStudyIntroTitle--e17a8";
export var caseStudyNameAndDescription = "styles-module--caseStudyNameAndDescription--291a8";
export var caseStudySection = "styles-module--caseStudySection--94083";
export var caseStudyTag = "styles-module--caseStudyTag--74e02";
export var caseStudyTextBlock = "styles-module--caseStudyTextBlock--7fa43";
export var caseStudyTitle = "styles-module--caseStudyTitle--cb636";
export var caseStudyTitleAndSubtitle = "styles-module--caseStudyTitleAndSubtitle--19bb4";
export var desktopVersion = "styles-module--desktopVersion--b5c9d";
export var genericTitle = "styles-module--genericTitle--c8c14";
export var greeting = "styles-module--greeting--4e505";
export var greetingSection = "styles-module--greetingSection--e0750";
export var hideNavBar = "styles-module--hideNavBar--dd41b";
export var hiding = "styles-module--hiding--ccaa7";
export var introTitle = "styles-module--introTitle--2af4d";
export var isAbsolute = "styles-module--isAbsolute--a0895";
export var isFixed = "styles-module--isFixed--b1f46";
export var isNotVisible = "styles-module--isNotVisible--045e0";
export var isVisible = "styles-module--isVisible--ed8dd";
export var listItem = "styles-module--listItem--23c3a";
export var mobileVersion = "styles-module--mobileVersion--65470";
export var module1 = "styles-module--module1--a23a2";
export var module2 = "styles-module--module2--bab2b";
export var moduleBullets = "styles-module--moduleBullets--47c15";
export var moduleDescription = "styles-module--moduleDescription--2432c";
export var moduleImage = "styles-module--moduleImage--a0dcc";
export var moduleImageContainer = "styles-module--moduleImageContainer--b23ae";
export var moduleImageFooter = "styles-module--moduleImageFooter--9e24b";
export var moduleImageFooterDescription = "styles-module--moduleImageFooterDescription--ffde2";
export var moduleImageFooterTitle = "styles-module--moduleImageFooterTitle--54e24";
export var moduleList = "styles-module--moduleList--81bc6";
export var moduleName = "styles-module--moduleName--e7b06";
export var moduleTag = "styles-module--moduleTag--60df4";
export var moduleTextBlock = "styles-module--moduleTextBlock--3c2e8";
export var notActive = "styles-module--notActive--fe7b1";
export var previousAndNextButtons = "styles-module--previousAndNextButtons--61543";
export var quoteAuthor = "styles-module--quoteAuthor--d997f";
export var quoteAuthorPosition = "styles-module--quoteAuthorPosition--8f00c";
export var quoteClosing = "styles-module--quoteClosing--0f2de";
export var quoteContent = "styles-module--quoteContent--f2d40";
export var quoteModule = "styles-module--quoteModule--86883";
export var quoteSymbol = "styles-module--quoteSymbol--7e34a";
export var quoteText = "styles-module--quoteText--d0397";
export var showNavBar = "styles-module--showNavBar--a418d";
export var textLeft = "styles-module--textLeft--e1bd0";
export var textRight = "styles-module--textRight--47368";
export var toggle = "styles-module--toggle--dae26";
export var toggleIconLeft = "styles-module--toggleIconLeft--f7dec";
export var toggleIconRight = "styles-module--toggleIconRight--3f796";
export var toggleText = "styles-module--toggleText--fece3";
export var toggleTextBold = "styles-module--toggleTextBold--23e83";